var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Watch, PropertyConverters, P, PCSS, Utils, PropertyChangeEvent } from '@pacem/pacem-core';
import { PacemFxElement } from './types';
//namespace Pacem.Components.Fx {
const FANCY_CSS = PCSS + "-fancy";
const FANCIFY_CSS = PCSS + "-fancify";
const DEFAULT_GAP = 20;
let PacemFxFancyElement = class PacemFxFancyElement extends PacemFxElement {
    constructor() {
        super(...arguments);
        this._progress = .0;
        this._started = false;
    }
    get progress() {
        return this._progress;
    }
    get started() {
        return this._started;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'fancify' || name === 'target') {
            if (!Utils.isNull(this.target)) {
                if (this.fancify) {
                    this.start();
                }
                else {
                    this._reset();
                }
            }
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        if (this.fancify && !Utils.isNull(this.target))
            this.start();
    }
    disconnectedCallback() {
        cancelAnimationFrame(this._handle);
        clearTimeout(this._handle1);
        if (!Utils.isNull(this.target))
            this._reset();
        super.disconnectedCallback();
    }
    _reset() {
        Utils.removeClass(this.target, FANCY_CSS);
        if (this._started) {
            this.dispatchEvent(new PropertyChangeEvent({ propertyName: 'started', oldValue: this._started, currentValue: this._started = false }));
        }
        this.dispatchEvent(new PropertyChangeEvent({ propertyName: 'progress', oldValue: this._progress, currentValue: this._progress = 0 }));
        if (Utils.isNull(this._originalContent))
            this._originalContent = this.target.innerHTML;
        else
            this.target.innerHTML = this._originalContent;
    }
    _parse() {
        let n, a = [], walker = document.createTreeWalker(this.target, NodeFilter.SHOW_TEXT);
        while (n = walker.nextNode()) {
            if (n.textContent) {
                a.push(n);
            }
        }
        this._textNodes = a;
    }
    start() {
        if (!this.disabled) {
            this._reset();
            this._parse();
            this._startShow();
            this._handle1 = setTimeout(() => {
                this.dispatchEvent(new PropertyChangeEvent({ propertyName: 'started', oldValue: this._started, currentValue: this._started = true }));
            }, this.delay || 0);
        }
    }
    _startShow(ndx = 0) {
        Utils.addClass(this.target, FANCY_CSS);
        const trunks = this._textNodes, length = trunks.length;
        this._fancify(trunks[ndx]);
        const old = this._progress;
        ndx++;
        const curr = this._progress = ndx / length;
        this.dispatchEvent(new PropertyChangeEvent({ propertyName: 'progress', oldValue: old, currentValue: curr }));
        if (ndx < length) {
            this._handle = requestAnimationFrame(() => {
                this._startShow(ndx);
            });
        }
    }
    _fancify(node) {
        const content = node.textContent;
        if (Utils.isNullOrEmpty(content) || !/[^\s]/.test(content)) {
            return;
        }
        const leftPad = /^\s/.test(content), rightPad = /\s$/.test(content);
        node.textContent = '';
        //
        const words = content.trim().split(' '), gap = this.gap || DEFAULT_GAP, delay = this.delay || 0;
        let j = 0;
        for (let word of words) {
            var span = document.createElement('span');
            span.className = FANCIFY_CSS;
            span.style.animationDelay = `${(delay + j * gap)}ms`;
            if (leftPad || j > 0)
                node.parentElement.insertBefore(document.createTextNode(' '), node);
            span.textContent = word;
            node.parentElement.insertBefore(span, node);
            j++;
        }
        //
        if (rightPad)
            node.parentElement.insertBefore(document.createTextNode(' '), node);
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemFxFancyElement.prototype, "fancify", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemFxFancyElement.prototype, "delay", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemFxFancyElement.prototype, "gap", void 0);
PacemFxFancyElement = __decorate([
    CustomElement({ tagName: P + '-fx-fancy' })
], PacemFxFancyElement);
export { PacemFxFancyElement };
